// Generated by pnpm icons:generate. Edit native source assets and semantic roles, not this file.
import { createCoreLineIcon } from '../CoreLineIcon';
export const ExpandIcon = /*#__PURE__*/ createCoreLineIcon(
  'expand',
  '0 0 14 14',
  '<g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m0.5 4 6.14645 6.1464c0.19526 0.1953 0.51184 0.1953 0.7071 0L13.5 4" stroke-width="1"></path></g>',
);
